import React from 'react'
import { format } from "date-fns";
import { Thead, Tbody, Tr, Td, Text, Box, Center } from "@chakra-ui/react";
import { Table} from "@chakra-ui/react";
import { BiServer } from "react-icons/all";
import "./TicketSaleReport.css";
import { ticketSalesColumn } from '../../../constants/tableData';
function TicketSaleReportTable({data, filter}) {
    
  return (
    <>
        <Box style={{ position: "sticky", left: "0"}} w="100%" mb="10px">
            <Text textAlign="center" fontSize="25px" fontWeight="bold">Ticket Sales for International Tourist Visit to Angkor</Text>
            <Text textAlign="center">Ticket Sales of {format(new Date(filter.dateFrom), "dd")} to {format(new Date(filter.dateTo), "dd, MMMM, yyyy")}</Text>
        </Box>
        
        {data?.length > 0 ? (
            <Table w="2000px" size="sm" className="sale-table" borderRight="1px solid black">
                <Thead className='sale-thead'>
                    <Tr color="#4149BE" fontWeight="bold" className='sale-thead-tr1'>
                        <Td rowSpan="3" colSpan="1" textAlign="center">Date</Td>
                        <Td rowSpan="2" colSpan="4" textAlign="center">Tourist (T)</Td>
                        <Td rowSpan="2" colSpan="4" textAlign="center">Revenue (R)</Td>
                        <Td rowSpan="1" colSpan="10" textAlign="center" px="0">ប្រភេទប័ណ្ណផ្សេងៗ ( សំបុត្រលក់អនឡាញ និង​ សំបុត្រសម្រាប់រយៈពេល ១០០$, ១៥០$, ២០០$​ )</Td>
                    </Tr>
                    <Tr color="#4149BE" fontWeight="bold" textAlign="center" h="35px" className='sale-thead-tr2'>
                        <Td rowSpan="1" colSpan="5" textAlign="center">Tourist Number Buy Online (TO)</Td>
                        <Td rowSpan="1" colSpan="5" textAlign="center">Tourist Number Long Pass (TL)</Td>
                    </Tr>
                    <Tr color="#4149BE" fontWeight="bold" textAlign="center" h="35px" className='sale-thead-tr3'>
                        <Td textAlign="center" p="0">T1D</Td>
                        <Td textAlign="center" p="0">T3Ds</Td>
                        <Td textAlign="center" p="0">T7Ds</Td>
                        <Td textAlign="center" p="0">T TOTAL</Td>
                        <Td textAlign="center" p="0">R1D</Td>
                        <Td textAlign="center" p="0">R3Ds</Td>
                        <Td textAlign="center" p="0">R7Ds</Td>
                        <Td textAlign="center" p="0">R TOTAL</Td>
                        <Td textAlign="center" p="0">TO1D</Td>
                        <Td textAlign="center" p="0">TO3Ds</Td>
                        <Td textAlign="center" p="0">TO7Ds</Td>
                        <Td textAlign="center" p="0">TO TOTAL</Td>
                        <Td textAlign="center" p="0">RO TOTAL</Td>
                        <Td textAlign="center" p="0">TL100</Td>
                        <Td textAlign="center" p="0">TL150</Td>
                        <Td textAlign="center" p="0">TL200</Td>
                        <Td textAlign="center" p="0">TO TOTAL5</Td>
                        <Td textAlign="center" p="0">RO TOTAL6</Td>
                    </Tr>
                </Thead>

                <Tbody>
                    {data?.map((val, index) =>  {
                        return (
                            <Tr key={index} h="25px">
                                {ticketSalesColumn.map((item, i) => {
                                    return (
                                        <Td 
                                            key={i} 
                                            w="150px" 
                                            textAlign="center" 
                                            height="35px" 
                                            py="0" 
                                            p="2px" 
                                            bg={(index===data.length-1) ? "#8497b0 !important" : "white" } 
                                            color={(index===data.length-1) ? "white !important" : "black" } 
                                        >
                                            {val[item.columnId]}
                                        </Td>
                                    )
                                })}
                            </Tr>
                        )
                    })}
                </Tbody>
            </Table>
        ) : (
            <Center py="3" w="full" h="70vh" color="gray.400">
                <BiServer size="1.3rem" /> <Text fontSize="md">&nbsp;No data.</Text>
            </Center>
        )}
    </>
  )
}

export default TicketSaleReportTable
